import { IIdenticalOffer } from '../../../types/identicalOffers';
import { IIdenticalOfferView } from '../../../types/identicalOffersView';
import { formatPrice } from './formatPrice';
import { formatAuthor } from './formatAuthor';
import { formatMedia } from './formatMedia';

export function mapIdenticalOffers(offers: IIdenticalOffer[]): IIdenticalOfferView[] {
  return offers.map(({ price, author, media, ...offer }) => ({
    ...offer,
    price: formatPrice(price),
    author: formatAuthor(author),
    media: formatMedia(media),
  }));
}
